/**
 * @generated SignedSource<<aa37790d0f3f4975f00d97e4ae9150a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type LeadStatusTypeEnum = "ConvertedToCustomer" | "InProgress" | "MarkAsSpam" | "NotConvertedToCustomer" | "Processed" | "Recieved";
import { FragmentRefs } from "relay-runtime";
export type saleByOwnerProcessedGridFragment$data = {
  readonly propertyForSaleByOwnerLeads: ReadonlyArray<{
    readonly __typename: string;
    readonly id: string;
    readonly statusType: LeadStatusTypeEnum | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"leadListItemFragment">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "saleByOwnerProcessedGridFragment";
};
export type saleByOwnerProcessedGridFragment$key = {
  readonly " $data"?: saleByOwnerProcessedGridFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"saleByOwnerProcessedGridFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "saleByOwnerProcessedGridFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "propertyForSaleByOwnerLeads",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "leadListItemFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d6d64df4c5a033ed148bac6ba70f8e82";

export default node;
